export default function SMEDealerPrivacyPolicyView() {
  return {
    view: (vnode) => {

      const { onChangeAccept } = vnode.attrs;

      return m("form",
        m("div",
          m("table[cellpadding='2'][cellspacing='2'][border='0'][width='100%']",
            m("tbody",
              m("tr",
                m("td[bgcolor='#EEEEEE']",
                  m("table[border='0'][cellpadding='2'][cellspacing='2'][width='100%']",
                    m("tbody",
                      m("tr[bgcolor='#0099ff']",
                        m("td",
                          m("h3", "SAMSUNG e-WARRANTY INCENTIVE PROGRAM (Terms & Conditions)")
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "1. Duration"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " This Agreement shall be valid for a period of stated above commencing from the date stated in above and the same may be extended for a further term of one (1) year subject to Samsung's absolute discretion. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "2. Retailer's obligations"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.1 In consideration of the e-Warranty Incentive, the Retailer agrees to participate in the e-Warranty Incentive Programme and the terms and conditions contained herein. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.2 The Retailer shall comply with the e-Warranty Incentive Programme procedure as stated below: "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " Upon purchase of any of the Products by the Customer, the Retailer shall, within the period prescribed by Samsung, procure the completed Application Form from the Customer. "
                            ),
                            m("li",
                              " Upon receipt of the Application Form, the Retailer shall, within a period prescribed by Samsung, submit the Required Information to one of the following:- ",
                              m("ol[type='a']",

                                m("li",
                                  "MCS Portal;"
                                ),
                                m("li",
                                  "e-Warranty Mobile Application;"
                                ),
                                m("li",
                                  "short messaging service (SMS) platform; or"
                                ),
                                m("li",
                                  " any other venues, methods or systems prescribed by Samsung "
                                )
                              )
                            ),
                            m("li",
                              " The Retailer shall deliver the Application Form to Samsung within seven (7) Business Days from the date of Samsung's written request. Alternatively, Samsung may collect the Application Form from the Retailer by providing three (3) Business Days prior written notice. "
                            ),
                            m("li",
                              " In the event that Samsung requested the Application Form to be delivered by courier, Samsung shall bear the cost of the delivery. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " 3.3 Samsung reserves its rights to amend or vary the e-Warranty Incentive Programme procedure. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.4 The Retailer shall exercise all due diligence in handling the Customer's registration and shall be responsible to ensure the details in the Application Form are correct and accurate. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.5 The Retailer shall only proceed with the registration of the Customer upon receiving the duly completed Applications Form or any other forms which indicate the Customer's intention to subscribe to e-Warranty Programme. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.6 The Retailer shall strictly follow the registration processes and procedures as prescribed by Samsung in effecting any Customer's registration. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.7 The Retailer shall not prescribe any unethical method in capturing Customer's registration including but not limited to:- "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              "fraud;"
                            ),
                            m("li",
                              "negligent;"
                            ),
                            m("li",
                              "misrepresentation;"
                            ),
                            m("li",
                              "omission; or"
                            ),
                            m("li",
                              "creating dummy accounts."
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " 3.8 In the event that Samsung discovers that the Retailer employed such methods in capturing registration, at Samsung’s option, the Retailer shall refund to Samsung or deduct the amount of incentive paid or payable to the Retailer. This right shall be in addition to Samsung's rights under this Agreement to terminate the Agreement. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 3.9 The Retailer shall ensure that in the Required Information are collected, processed and procured in a lawful manner. The Retailer shall be under obligation to protect the Required Information from unauthorized and/or accidental access, unauthorized processing, deletion, alteration, disclosure or destruction of the Required Information and shall be responsible to take all and every security measures deemed necessary for execution of this obligation. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "4. e-Warranty Incentives"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 4.1 The e-Warranty Incentive shall be calculated based on the successful registration of the Products within the valid period of the e-Warranty Incentive Programme. The amount payable under the e-Warranty Incentive Programme will be solely determined by Samsung and may subject to change throughout the valid period of the e-Warranty Incentive Programme. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 4.2 Samsung will verify the actual sales of the Products based on the information submitted by the Retailer and Retail Assistant. In the event of any discrepancies between the information submitted by the Retailer and Retail Assistant, Samsung shall at its sole absolute discretion determine the amount payable to the Retailer. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 4.3 Upon successful and satisfactory verification, Samsung shall at its sole absolute discretion make payment of the e-Warranty Incentive to the Retailer. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 4.4 Samsung reserves its right to reject or refuse any information submitted by the Retailer if such submission is invalid due to, but not limited to, the following situations: "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " the Retailer activated the e-Warranty Programme before selling the Product to the Customer; "
                            ),
                            m("li",
                              " IMEI was already used or had been activated before; and "
                            ),
                            m("li",
                              " Retailer did not submit the Required Information within the period prescribed by Samsung. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " 4.5 In addition, if the Retailer or Retail Assistant is found to be in violation of the situations as mentioned in Clause 4.4 above, Samsung shall be entitled to impose a penalty to deduct or set-off the e-Warranty Incentive based on the rates below: "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " First offence – 50% of total weekly e-Warranty Incentive "
                            ),
                            m("li",
                              " Second offence – 100% of the weekly e-Warranty Incentive; and "
                            ),
                            m("li",
                              " Third offence and above – 100% of the monthly e-Warranty Incentive or immediate termination of this Agreement by Samsung. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "5. Use of MCS Portal and e-Warranty Mobile Application"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 5.1 Subject to the compliance of the terms and conditions herein, Samsung grants the Retailer a non-exclusive, non-transferable licence, without the right to sublicense, to use and access the MCS Portal and/or e-Warranty Mobile Application. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 5.2 The Retailer shall adhere to any terms and conditions imposed for the use of the MCS Portal and/or e-Warranty Mobile Application. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 5.3 The Retailer shall be under obligation to protect the account assigned by Samsung at all times from unauthorized and/or accidental access and/or unauthorized use and to promptly notify Samsung if it suspects any unauthorized use of said the account. The Retailer shall ensure that there is no abuse or misuse of the said account by its servants, agents or employees and shall remain responsible for such abuse or misuse by its servants, agents or employees at all time.{\" \"} "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 5.4 Samsung reserves the rights to suspend or restrict the Retailer to use or access the MCS Portal or the e-Warranty Mobile Application if the Retailer or its servants, agents or employees does the following: "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " misuses the MCS Portal and/or the e-Warranty Mobile Application; "
                            ),
                            m("li",
                              "commits fraudulent or unauthorized access;"
                            ),
                            m("li",
                              "tampers with the registration process;"
                            ),
                            m("li",
                              " commits any activities that are inconsistent with the uses the MCS Portal and/or the e-Warranty Mobile Application. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " 5.5 Samsung reserves the right to modify, suspend, or discontinue the MCS Portal and/or e-Warranty Mobile Application (or any part or content thereof) at any time with or without notice, and Samsung will not be liable to the Retailer or to any third party should it exercise such rights. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 5.6 Samsung also reserves the right at any time to modify this Agreement and to impose new or additional terms or conditions on the use of the MCS Portal and/or e-Warranty Mobile Application. Such modifications and additional terms and conditions will be effective immediately and incorporated into this Agreement. The continued use of the MCS Portal and e-Warranty Mobile Application will be deemed acceptance thereof. If the Retailer refuses or rejects any such modifications and additional terms and conditions, this Agreement shall be terminated immediately. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "6 Indemnity"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " The Retailer shall indemnify and keep indemnified Samsung:- "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " Against any and all losses, claims, demands, actions, proceedings, damages, costs or expenses or any other liability whatsoever which the other may suffer or incur arising in any way from this Agreement, any act, omission or default of the retailer or its officers, employees or agents or otherwise in the exercise or purported exercise by the Retailer of the rights given in this Agreement or otherwise; or "
                            ),
                            m("li",
                              " Against all actions, claims, demands, costs, charges, expenses, government seizures, forfeiture and consequences arising from or incurred by reason of any infringement of any legislation, act, regulation, ordinance, etc. enforced in Malaysia. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "7 Confidentiality"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 7.1 The Parties agree that any information owned by a Party and disclosed by it (\"disclosing Party\") to the other Party (\"receiving Party\") under this Agreement shall be regarded as confidential information. The Parties shall only make use of such disclosed confidential information between them to the extent required to fulfil their respective obligations under this Agreement and shall only disclose the confidential information to their respective employees, consultants and agents (collectively, \"Personnel\") on a \"need-to-know\" basis only. The Parties shall ensure that their respective Personnel observe the confidentiality requirement under this clause. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 7.2 Save as provided under Clause 7.1, no disclosure shall be made by a receiving Party to any third party without the prior written consent of the disclosing Party. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 7.3 The receiving Party further agree that it shall not utilize, use or exploit the disclosing Party’s confidential information other than for the purpose for which it is disclosed without the prior written consent of the disclosing Party, including, but not limited to, for purposes of competing in any way with the other Party. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "8 Termination"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 8.1 Termination of this Agreement may be occasioned in the event that – "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " The Retailer shall be dissolved, cease to do business, becomes insolvent, enters into bankruptcy proceedings or be subject to winding up, compromise, arrangement or receivership proceedings; or "
                            ),
                            m("li",
                              " The Retailer fails to take sufficient steps to remedy any material breach of this Agreement within three (3) Business Days of written notice by Samsung and requiring the default to be remedied. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          " 8.2 Notwithstanding the above, Samsung shall be entitled to terminate this Agreement without assigning any reason by providing seven (7) Business Days prior written notice to Retailer. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "9 Consequence of Termination"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " In the event of termination of this Agreement for whatsoever reasons: "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              " the use or access to the MCS Portal or the e-Warranty Mobile Application shall be suspended; "
                            ),
                            m("li",
                              " any completed applications together with the relevant supporting documents in the custody of the Retailer such as the Application Form shall immediately be submitted to Samsung and shall belong absolutely to Samsung whether it has been registered or not in the MCS Portal or the e-Warranty Mobile Application; "
                            ),
                            m("li",
                              " the Retailer shall continue to comply with all of the obligations on the part of the Retailer under this Agreement which are not affected by termination; "
                            ),
                            m("li",
                              " the Retailer shall have no further right to run the e-Warranty Programme and to cease all activities in relation to the e-Warranty Programme; "
                            ),
                            m("li",
                              " both Parties shall return to the other the confidential information supplied to each respective Party hereto pursuant to this Agreement; "
                            ),
                            m("li",
                              " the Retailer shall erase all proprietary information and data provided by Samsung and Required Information and all copies of any part of the proprietary information and data provided by Samsung and Customers. "
                            ),
                            m("li",
                              " any claim which either party may have against the other in respect of any breach or non-performance or repudiation of any of the provisions of this Agreement which shall have occurred prior to such termination shall not be affected or prejudiced and all rights of termination under this Agreement "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 9.1 Any communication from one party to another party shall be deemed to be received by such other party (if sent by email) upon acknowledgement of receipt by the other party, or (in any other case) when left at the address required by the preceding clause or two (2) days after being sent by registered post addressed to that address. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 9.2 For the purpose of this Clause, each of the parties hereto shall from time to time notify the other party in writing of an address in Malaysia where such communication as aforesaid can be given or served and such notification shall be effective only when it is actually received. In the absence of such notification, the communication aforesaid may be given or served at the email and addresses of the respective parties hereinbefore set out. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "10 Assignment and Sub-Contracting"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 10.1 This Agreement will be binding upon and inure for the benefit of the successors of the parties hereto but shall not be assignable by any party without the prior written consent of the other. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 10.2 Samsung may assign the benefit of this Agreement (including, without limitation to the Warranties) to their respective heirs, personal representatives, any successor in title or any permitted assigns of Samsung. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "11 No partnership or agency"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " The provisions of this Agreement will not be construed or taken to constitute:- "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("ol",
                            m("li",
                              "a partnership between the parties; or"
                            ),
                            m("li",
                              " either party to be the agent of the other party; or "
                            ),
                            m("li",
                              " an authority to either party to represent or bind or pledge the credit of the other party in anyway. "
                            )
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("b",
                            "12 Time"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " Time wherever mentioned shall be deemed to be treated as the essence of this Agreement. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "13 Survivability"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " The terms of Clauses 3.8, 6, 7 and 9 shall survive termination of this Agreement. If the parties have executed a separate agreement that contains confidentiality terms prior to or contemporaneously with this Agreement, those separate confidentiality terms shall remain in full force to the extent they do not conflict. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "14 Severability"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 14.1 The provisions in this Agreement are separate and independent of each other and any provision, which is invalid or unenforceable, shall be ineffective only to the extent of such invalidity or unenforceability without affecting the validity or enforceability of any other provisions in this Agreement. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 14.2 Notwithstanding the foregoing, the parties agree that should any provision of this{\" \"} "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " 14.3 Agreement is illegal, void, prohibited or unenforceable, then the parties shall forthwith enter into good faith negotiations to amend such provision in such a way that after amendment, it is valid, legal and/or enforceable and to the maximum extent possible, carries out the original intent of the parties as to the matter(s) in question. "
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          m("b",
                            "15 Governing Law"
                          )
                        )
                      ),
                      m("tr",
                        m("td",
                          m("br"),
                          " This Agreement shall be governed by and construed in accordance with the laws of Malaysia and the Parties unequivocally agree to submit to exclusive jurisdiction of the courts of Malaysia. "
                        )
                      )

                    )
                  )
                )
              )
            )
          ),
          m("table[border='0'][cellpadding='2'][cellspacing='2'][width='100%']",
            m("tbody",
              m("tr",
                m("td",
                  m("input[type='checkbox'][id='chkAccept'][name='chkAccept']", { onchange: onChangeAccept }),
                  " By submitting this application, I/we confirm that I/we have read the TERMS & CONDITIONS and I/we accept all the terms and conditions therein. "
                )
              )
            )
          )

        )
      )
    }
  }
}

